import { IGenList, QList, GenData } from '@educraft/base';

/**
 * A list generator that maps keys and values from a collection of items.
 * Port of C# EduFrame.OrderGen.Generators.SimpleArray.
 */
export class SimpleArrayList<T> implements IGenList {
  private readonly items: QList;

  constructor(
    source: T[],
    keySelector: (item: T) => string,
    valueSelector: (item: T) => string
  ) {
    this.items = {
      items: source.map((item) => ({
        key: keySelector(item),
        value: valueSelector(item),
      })),
    };
  }

  generate(data: GenData): QList {
    return this.items;
  }
}
